import * as React from 'react';

import { Checkbox, Toolbar, Typography } from '@mui/material';
import {
  CustomTableCellCheckBox,
  CustomTableCellDownload,
  CustomTableCellReportStatus,
  CustomTableCellRimStatus,
  CustomTableCellText,
  CustomTableCellTextNonValid,
  CustomTableSentDateAndRefresh
} from './material-ui-styles';

import { CommunicationOverviewSvsItemForDisplay } from '../../../../store/details/overview/types';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { Paper, Table, TableBody, TableRow } from '@mui/material';
import { generateSvsReports } from '../../../../store/details/overview/actions';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './overview.module.css';
import { BelfiusTooltip } from 'src/components/custom/belfius-tooltip';

interface Props {
  readonly title: string;
  readonly rows: CommunicationOverviewSvsItemForDisplay[];
  readonly toggleItem: (id: number) => void;
  readonly togleAll?: (checked: boolean) => void;
  readonly toggleAllChecked: boolean;
  readonly currentLanguage: string;
  readonly generateSvsReports: typeof generateSvsReports;
  readonly caseCode: string;
  readonly handleDownloadClick: (amazonKey: string, filename: string) => void; // Handle independently
  readonly caseBlocked: boolean;
}

type AllProps = Props;

export class OverviewTableSvs extends React.Component<AllProps> {
  private localization: Ii18n;
  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <Paper>
        <Toolbar className={styles.toolbar}>
          <Typography variant='h5' id='tableTitle'>
            {this.props.title}
          </Typography>
        </Toolbar>

        <Table className={styles.table}>
          <TableBody>
            {this.props.rows.map(row => {
              return (
                <TableRow hover key={row.id()}>
                  <CustomTableCellCheckBox padding='checkbox'>
                    <Checkbox
                      disabled={!row.canDelete() || this.props.caseBlocked}
                      checked={row.selected()}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => { this.props.toggleItem(row.id()); }}
                    />
                  </CustomTableCellCheckBox>
                  {!row.isValid() && <CustomTableCellTextNonValid>
                    {`${row.id()} (${this.localization.getFormatedDate(row.date(), this.props.currentLanguage)})`}
                  </CustomTableCellTextNonValid>}

                  {row.isValid() && <CustomTableCellText>
                    {`${row.id()} (${this.localization.getFormatedDate(row.date(), this.props.currentLanguage)})`}
                  </CustomTableCellText>}

                  <CustomTableCellReportStatus>
                    <RefreshIcon onClick={() => {
                      if (this.props.caseBlocked) { return; }
                      this.props.generateSvsReports(this.props.caseCode, [row.id()]); }}>refresh</RefreshIcon>
                  </CustomTableCellReportStatus>

                  <CustomTableCellRimStatus>
                    {/* RIM STATUS */}
                  </CustomTableCellRimStatus>

                  <CustomTableCellDownload>
                    {row.documentAmazonKey() ? <div className={styles.link} onClick={() => this.props.handleDownloadClick(row.documentAmazonKey(), 'svs-' + row.id().toString())}>{this.localization.get('shared.download')}</div> : ''}
                  </CustomTableCellDownload>
                  <CustomTableCellDownload>
                    {row.daccaRikAmazonKey() ? <div className={styles.link} onClick={() => this.props.handleDownloadClick(row.daccaRikAmazonKey(), 'dacca-' + row.id().toString())}>{this.localization.get('shared.downloadDaccaRik')}</div> : ''}
                  </CustomTableCellDownload>
                  <CustomTableSentDateAndRefresh scope='row'>
                    {this.localization.getFormatedDateTime(row.sentOn(), this.props.currentLanguage)}
                  </CustomTableSentDateAndRefresh>
                  <CustomTableCellCheckBox>
                    {row.needsApproval() ?
                    <BelfiusTooltip title={row.createdByName()}>
                    <div>
                      <CheckCircleOutlineIcon
                        aria-owns='simple-menu'
                        aria-haspopup='true'>check_circle_outline</CheckCircleOutlineIcon>
                    </div>
                  </BelfiusTooltip> : '' }
                  </CustomTableCellCheckBox>

                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}
